// ECharts with only the parts the app uses (keeps the chart bundle small).
import { BarChart, GaugeChart, LineChart, ScatterChart } from 'echarts/charts';
import {
  AxisPointerComponent,
  DataZoomComponent,
  GridComponent,
  LegendComponent,
  MarkAreaComponent,
  MarkLineComponent,
  ToolboxComponent,
  TooltipComponent,
  VisualMapComponent,
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([
  LineChart,
  BarChart,
  ScatterChart,
  GaugeChart,
  GridComponent,
  TooltipComponent,
  LegendComponent,
  AxisPointerComponent,
  DataZoomComponent,
  MarkLineComponent,
  MarkAreaComponent,
  ToolboxComponent,
  VisualMapComponent,
  CanvasRenderer,
]);

export { echarts };
// Types only: nothing from the full bundle is pulled in at runtime.
export type { EChartsOption } from 'echarts';
export type { EChartsType as ECharts } from 'echarts/core';
